import React, { useState, useEffect } from "react";
import {
  Container,
  Paper,
  Typography,
  TextField,
  Button,
  makeStyles,
  Box,
  CircularProgress,
  Snackbar,
  Grid,
  Divider,
  IconButton,
  InputAdornment,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Card,
  CardContent,
  MenuItem,
  FormControl,
  InputLabel,
  Select,
  useMediaQuery,
  useTheme,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Drawer,
  AppBar,
  Toolbar,
  Avatar,
  Chip,
  Popper,
  Radio,
  FormControlLabel,
} from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";
import FiberManualRecordIcon from "@material-ui/icons/FiberManualRecord";
import AddIcon from "@material-ui/icons/Add";
import RemoveIcon from "@material-ui/icons/Remove";
import EventIcon from "@material-ui/icons/Event";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import ShoppingCartIcon from "@material-ui/icons/ShoppingCart";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import ExpandLessIcon from "@material-ui/icons/ExpandLess";
import AiSensyLogo from "../../static/AiSensyLogo.svg";
import { INTEGRATION_SERVER_URL } from "../../config/config";
import axios from "axios";
import { useParams } from "react-router-dom";
import PeopleIcon from "@material-ui/icons/People";
import AccessTimeIcon from "@material-ui/icons/AccessTime";
import WarningIcon from "@material-ui/icons/Warning";
import { countries } from "./countryData"; // We'll create this file in a moment

// Custom SVG icon components instead of using lucide-react
const MapPinIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z"></path>
    <circle cx="12" cy="10" r="3"></circle>
  </svg>
);

const MessageSquareIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path>
  </svg>
);

const GlobeIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <circle cx="12" cy="12" r="10"></circle>
    <line x1="2" x2="22" y1="12" y2="12"></line>
    <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"></path>
  </svg>
);

const BriefcaseIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <rect width="20" height="14" x="2" y="7" rx="2" ry="2"></rect>
    <path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"></path>
  </svg>
);

const CalendarIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <rect width="18" height="18" x="3" y="4" rx="2" ry="2"></rect>
    <line x1="16" x2="16" y1="2" y2="6"></line>
    <line x1="8" x2="8" y1="2" y2="6"></line>
    <line x1="3" x2="21" y1="10" y2="10"></line>
  </svg>
);

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(8),
    background: `linear-gradient(135deg, #f9fcfa 0%, #f5f5f5 100%)`,
    backgroundImage: `
      url("data:image/svg+xml,%3Csvg width='120' height='120' viewBox='0 0 120 120' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M9 0h2v20H9V0zm25.134.84l1.732 1-10 17.32-1.732-1 10-17.32zm-20 20l1.732 1-10 17.32-1.732-1 10-17.32zM58.16 4.134l1 1.732-17.32 10-1-1.732 17.32-10zm-40 40l1 1.732-17.32 10-1-1.732 17.32-10zM80 9v2H60V9h20zm20 69v2H0v-2h20zm79.32-55l-1 1.732-17.32-10L82 4l17.32 10zm-80 80l-1 1.732-17.32-10L2 84l17.32 10zm96.546-75.84l-1.732 1-10-17.32 1.732-1 10 17.32zm-100 100l-1.732 1-10-17.32 1.732-1 10 17.32zM38.16 24.134l1 1.732-17.32 10-1-1.732 17.32-10zM60 29v2H40v-2h20zm19.32 5l-1 1.732-17.32-10L62 24l17.32 10zm16.546 4.16l-1.732 1-10-17.32 1.732-1 10 17.32zM111 40h-2V20h2v20zm3.134.84l1.732 1-10 17.32-1.732-1 10-17.32zM40 49v2H20v-2h20zm19.32 5l-1 1.732-17.32-10L42 44l17.32 10zm16.546 4.16l-1.732 1-10-17.32 1.732-1 10 17.32zM91 60h-2V40h2v20zm3.134.84l1.732 1-10 17.32-1.732-1 10-17.32zm24.026 3.294l1 1.732-17.32 10-1-1.732 17.32-10zM39.32 74l-1 1.732-17.32-10L22 64l17.32 10zm16.546 4.16l-1.732 1-10-17.32 1.732-1 10 17.32zM71 80h-2V60h2v20zm3.134.84l1.732 1-10 17.32-1.732-1 10-17.32zm24.026 3.294l1 1.732-17.32 10-1-1.732 17.32-10zM120 89v2h-20v-2h20zm-84.134 9.16l-1.732 1-10-17.32 1.732-1 10 17.32zM51 100h-2V80h2v20zm3.134.84l1.732 1-10 17.32-1.732-1 10-17.32zm24.026 3.294l1 1.732-17.32 10-1-1.732 17.32-10zM100 109v2H80v-2h20zm19.32 5l-1 1.732-17.32-10 1-1.732 17.32 10zM31 120h-2v-20h2v20z' fill='%2304cf66' fill-opacity='0.02' fill-rule='evenodd'/%3E%3C/svg%3E"),
      radial-gradient(circle at 25% 10%, rgba(4, 207, 102, 0.05) 0%, rgba(4, 207, 102, 0) 20%),
      radial-gradient(circle at 75% 90%, rgba(4, 207, 102, 0.05) 0%, rgba(4, 207, 102, 0) 20%),
      linear-gradient(135deg, #f9fcfa 0%, #f5f5f5 100%)
    `,
    backgroundAttachment: "fixed",
    position: "relative",
    minHeight: "100vh",
    "&:before": {
      content: '""',
      position: "absolute",
      top: 0,
      left: 0,
      right: 0,
      height: "180px",
      background: `linear-gradient(180deg, rgba(4, 207, 102, 0.08) 0%, rgba(4, 207, 102, 0) 100%)`,
      zIndex: 0,
    },
    [theme.breakpoints.down("sm")]: {
      padding: theme.spacing(3, 1.5),
      paddingTop: theme.spacing(4),
      paddingBottom: theme.spacing(6),
    },
  },

  // Header and branding
  headerLogo: {
    display: "flex",
    alignItems: "center",
    marginBottom: theme.spacing(2),
    [theme.breakpoints.down("sm")]: {
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(3),
      justifyContent: "center",
    },
  },
  logo: {
    height: 35,
    marginRight: theme.spacing(1),
  },
  eventBadges: {
    display: "flex",
    flexWrap: "wrap",
    gap: theme.spacing(1),
    marginBottom: theme.spacing(2),
    [theme.breakpoints.down("sm")]: {
      justifyContent: "center",
      marginBottom: theme.spacing(3),
    },
  },
  eventBadge: {
    backgroundColor: "#f0f9f1",
    color: "#04cf66",
    fontWeight: 500,
    border: "1px solid #e0f2e9",
    "& .MuiChip-icon": {
      color: "#04cf66",
    },
  },
  businessChip: {
    backgroundColor: "#FFF8E1",
    color: "#FF9800",
    fontWeight: 500,
    border: "1px solid #FFE0B2",
    "& .MuiChip-icon": {
      color: "#FF9800",
    },
  },
  dubaiChip: {
    backgroundColor: "#FFF8E1",
    color: "#FF9800",
    fontWeight: 500,
    border: "1px solid #FFE0B2",
    "& .MuiChip-icon": {
      color: "#FF9800",
    },
  },
  whatsappChip: {
    backgroundColor: "#E8F5E9",
    color: "#25D366",
    fontWeight: 500,
    border: "1px solid #C8E6C9",
    "& .MuiChip-icon": {
      color: "#25D366",
    },
  },
  aiChip: {
    backgroundColor: "#E3F2FD",
    color: "#2196F3",
    fontWeight: 500,
    border: "1px solid #BBDEFB",
    "& .MuiChip-icon": {
      color: "#2196F3",
    },
  },

  container: {
    position: "relative",
    zIndex: 1,
    [theme.breakpoints.down("sm")]: {
      padding: theme.spacing(0, 1),
    },
  },
  eventTitle: {
    fontSize: "28px",
    fontWeight: 700,
    marginBottom: theme.spacing(1),
    fontFamily: "'Poppins', 'Roboto', 'Helvetica', 'Arial', sans-serif",
    letterSpacing: "0.2px",
    [theme.breakpoints.down("sm")]: {
      textAlign: "center",
      fontSize: "24px",
      marginBottom: theme.spacing(2),
    },
  },
  eventDate: {
    display: "flex",
    alignItems: "center",
    // marginBottom: theme.spacing(3),
    color: "#666",
    // backgroundColor: "#f0f9f1",
    padding: theme.spacing(1, 0),
    borderRadius: "20px",
    display: "inline-flex",
    fontSize: "14px",
    fontWeight: 600,
    [theme.breakpoints.down("sm")]: {
      justifyContent: "center",
      // marginBottom: theme.spacing(4),
      width: "100%",
    },
  },
  eventDateText: {
    fontWeight: 600,
    letterSpacing: "0.3px",
  },
  lucideIcon: {
    marginRight: theme.spacing(1),
    verticalAlign: "middle",
    color: "inherit",
  },
  // Left Column Styles
  passCard: {
    padding: theme.spacing(2),
    borderRadius: "12px",
    boxShadow: "0 2px 12px rgba(0,0,0,0.04)",
    marginBottom: theme.spacing(2),
    backgroundColor: "#ffffff",
    border: "1px solid rgba(234, 234, 234, 0.8)",
    transition: "transform 0.2s, box-shadow 0.2s",
    position: "relative",
    overflow: "hidden",
    "&:before": {
      content: '""',
      position: "absolute",
      top: 0,
      left: 0,
      width: "5px",
      height: "100%",
      background: "linear-gradient(to bottom, #04cf66, #04cf66aa)",
      borderTopLeftRadius: "12px",
      borderBottomLeftRadius: "12px",
    },
    "&:after": {
      content: '""',
      position: "absolute",
      bottom: 15,
      right: 15,
      width: "80px",
      height: "80px",
      backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' width='24' height='24'%3E%3Cpath fill='none' d='M0 0h24v24H0z'/%3E%3Cpath d='M7.253 18.494l.724.423A7.953 7.953 0 0 0 12 20a8 8 0 1 0-8-8c0 1.436.377 2.813 1.084 4.024l.422.724-.653 2.401 2.4-.655zM2.004 22l1.352-4.968A9.954 9.954 0 0 1 2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10a9.954 9.954 0 0 1-5.03-1.355L2.004 22zM8.391 7.308c.134-.01.269-.01.403-.004.054.004.108.01.162.016.159.018.334.115.393.249.298.676.588 1.357.868 2.04.062.152.025.347-.093.537a4.38 4.38 0 0 1-.263.372c-.113.145-.356.411-.356.411s-.099.118-.061.265c.014.056.06.137.102.205l.059.095c.256.427.6.86 1.02 1.268.12.116.237.235.363.346.468.413.998.75 1.57 1l.005.002c.085.037.128.057.252.11.062.026.126.049.191.066a.35.35 0 0 0 .367-.13c.724-.877.79-.934.796-.934v.002a.482.482 0 0 1 .378-.127c.06.004.121.015.177.04.531.243 1.4.622 1.4.622l.582.261c.098.047.187.158.19.265.004.067.01.175-.013.373-.032.259-.11.565-.217.793-.124.27-.353.45-.646.478-.156.014-.289.017-.424.012-.142-.007-.326-.06-.453-.074-.08-.008-.158-.018-.232-.036-.458-.115-.911-.395-1.24-.644-.55-.41-.856-.685-1.29-1.137-.882-.93-1.49-1.802-1.884-2.779-.1-.248-.176-.497-.255-.747-.034-.107-.064-.214-.094-.32-.064-.227-.125-.455-.18-.682-.115-.466-.36-.958-.134-1.529.097-.231.263-.364.466-.412z' fill='rgba(37, 211, 102, 0.07)'/%3E%3C/svg%3E")`,
      backgroundRepeat: "no-repeat",
      backgroundSize: "contain",
      opacity: 0.3,
      pointerEvents: "none",
    },
    [theme.breakpoints.down("sm")]: {
      marginBottom: theme.spacing(1.7),
    },
  },
  passTitle: {
    fontSize: "17px",
    fontWeight: 600,
    marginBottom: theme.spacing(1),
    color: "#222",
    fontFamily: "'Poppins', 'Roboto', 'Helvetica', 'Arial', sans-serif",
  },
  passDescription: {
    color: "#555",
    marginBottom: theme.spacing(1.5),
    lineHeight: 1.4,
    fontSize: "13.5px",
    fontFamily: "'Inter', 'Roboto', 'Helvetica', 'Arial', sans-serif",
  },
  featureList: {
    padding: 0,
    marginBottom: theme.spacing(1.5),
  },
  featureItem: {
    padding: theme.spacing(0.1, 0),
  },
  featureIcon: {
    minWidth: "20px",
    color: "#000",
  },
  featureBullet: {
    fontSize: "8px",
    color: "#04cf66",
  },
  featureText: {
    fontSize: "13px",
    lineHeight: 1.4,
    color: "#444",
    fontFamily: "'Inter', 'Roboto', 'Helvetica', 'Arial', sans-serif",
  },
  passActions: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginTop: theme.spacing(1.5),
    paddingTop: theme.spacing(1),
    borderTop: "1px solid rgba(0,0,0,0.05)",
  },
  passPrice: {
    fontSize: "22px",
    fontWeight: 700,
    color: "#04cf66",
    fontFamily: "'Poppins', 'Roboto', 'Helvetica', 'Arial', sans-serif",
  },
  addToCartButton: {
    backgroundColor: "#04cf66",
    color: "#fff",
    padding: "10px 18px",
    borderRadius: "4px",
    fontWeight: 600,
    textTransform: "none",
    fontSize: "14px",
    fontFamily: "'Poppins', 'Roboto', 'Helvetica', 'Arial', sans-serif",
    "&:hover": {
      backgroundColor: "#03b85a",
    },
  },
  quantityControl: {
    display: "flex",
    alignItems: "center",
    border: "1px solid #eaeaea",
    borderRadius: "50px",
    padding: "4px",
    backgroundColor: "#f0f9f1",
  },
  quantityButton: {
    padding: 0,
    minWidth: "35px",
    height: "35px",
    borderRadius: "50%",
    backgroundColor: "#ffffff",
    boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
    color: "#04cf66",
    border: "1px solid #e0f2e9",
    "&:hover": {
      backgroundColor: "#e0f2e9",
    },
  },
  quantityPlusButton: {
    padding: 0,
    minWidth: "35px",
    height: "35px",
    borderRadius: "50%",
    backgroundColor: "#04cf66",
    boxShadow: "0 1px 5px rgba(4, 207, 102, 0.3)",
    color: "#ffffff",
    border: "1px solid #04cf66",
    "&:hover": {
      backgroundColor: "#03b85a",
    },
  },
  quantityValue: {
    margin: "0 8px",
    minWidth: "12px",
    textAlign: "center",
    fontWeight: 600,
    fontSize: "14px",
  },
  addToCartText: {
    fontSize: "13px",
    color: "#666",
    fontStyle: "italic",
    marginTop: theme.spacing(0.5),
  },
  multiMemberNote: {
    fontSize: "12px",
    color: "#666",
    fontStyle: "italic",
    marginTop: theme.spacing(0.5),
    fontWeight: 500,
  },

  // Right Column Styles
  summaryCard: {
    borderRadius: "12px",
    boxShadow: "0 1px 3px rgba(0,0,0,0.05)",
    backgroundColor: "#ffffff",
    position: "sticky",
    top: "324px",
    border: "1px solid #eaeaea",
    transition: "box-shadow 0.2s",
    overflow: "hidden",
    "&:hover": {
      boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
    },
    "&:after": {
      content: '""',
      position: "absolute",
      top: 0,
      right: 0,
      width: "100%",
      height: "5px",
      background: "linear-gradient(to right, #04cf66, #04cf66aa)",
    },
  },
  summaryTitle: {
    fontSize: "20px",
    fontWeight: 600,
    marginBottom: theme.spacing(1.5),
    borderBottom: "2px solid #04cf66",
    paddingBottom: theme.spacing(0.5),
    display: "inline-block",
    fontFamily: "'Poppins', 'Roboto', 'Helvetica', 'Arial', sans-serif",
    letterSpacing: "0.2px",
  },
  summaryItem: {
    display: "flex",
    justifyContent: "space-between",
    marginBottom: theme.spacing(1),
    alignItems: "center",
  },
  summaryItemName: {
    flexGrow: 0.8,
    fontSize: "15px",
    fontFamily: "'Inter', 'Roboto', 'Helvetica', 'Arial', sans-serif",
    fontWeight: 500,
    color: "#333",
  },
  summaryItemQty: {
    marginRight: theme.spacing(1),
    color: "#555",
    width: "24px",
    textAlign: "center",
    fontSize: "14px",
    fontWeight: 500,
  },
  summaryItemPrice: {
    fontWeight: 600,
    // width: "60px",
    textAlign: "right",
    fontSize: "15px",
    color: "#222",
    fontFamily: "'Inter', 'Roboto', 'Helvetica', 'Arial', sans-serif",
  },
  divider: {
    margin: theme.spacing(1, 0),
  },
  subtotalRow: {
    display: "flex",
    justifyContent: "space-between",
    marginBottom: theme.spacing(0.5),
    fontSize: "14px",
    fontFamily: "'Inter', 'Roboto', 'Helvetica', 'Arial', sans-serif",
    color: "#666",
  },
  totalRow: {
    display: "flex",
    justifyContent: "space-between",
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1.5),
    backgroundColor: "rgba(4, 207, 102, 0.05)",
    padding: theme.spacing(1),
    borderRadius: "6px",
  },
  totalLabel: {
    fontSize: "15px",
    fontWeight: 600,
    color: "#222",
    fontFamily: "'Poppins', 'Roboto', 'Helvetica', 'Arial', sans-serif",
  },
  totalAmount: {
    fontSize: "17px",
    fontWeight: 700,
    color: "#04cf66",
    fontFamily: "'Poppins', 'Roboto', 'Helvetica', 'Arial', sans-serif",
  },
  couponSection: {
    marginTop: theme.spacing(1.5),
    marginBottom: theme.spacing(1.5),
  },
  couponLabel: {
    marginBottom: theme.spacing(0.5),
    fontWeight: 600,
    fontSize: "14px",
    color: "#222",
    fontFamily: "'Poppins', 'Roboto', 'Helvetica', 'Arial', sans-serif",
  },
  couponInput: {
    display: "flex",
    alignItems: "center",
  },
  couponTextField: {
    flexGrow: 1,
    marginRight: theme.spacing(1),
    "& .MuiOutlinedInput-root": {
      borderRadius: "4px",
    },
    "& .MuiOutlinedInput-input": {
      padding: "8px 12px",
    },
    "&.MuiTextField-root": {
      padding: "0px",
    },
  },
  couponButton: {
    height: "36px",
    padding: "0 12px",
    backgroundColor: "#ffffff",
    color: "#04cf66",
    border: "1px solid #04cf66",
    borderRadius: "4px",
    fontWeight: 500,
    textTransform: "none",
    "&:hover": {
      backgroundColor: "#f0f9f1",
    },
    "&.Mui-disabled": {
      backgroundColor: "#f0f9f1",
      color: "#83d9b2",
      border: "1px solid #c8f0db",
      opacity: 0.8,
    },
  },
  successText: {
    color: "#04cf66",
    display: "flex",
    alignItems: "center",
    marginTop: theme.spacing(0.5),
    fontSize: "13px",
  },
  successIcon: {
    marginRight: theme.spacing(0.5),
    fontSize: "14px",
    color: "#04cf66",
  },
  errorText: {
    color: theme.palette.error.main,
    marginTop: theme.spacing(0.5),
    fontSize: "13px",
  },
  proceedButton: {
    padding: theme.spacing(1.25, 0),
    backgroundColor: "#04cf66",
    color: "#ffffff",
    "&:hover": {
      backgroundColor: "#03b85a",
    },
    marginTop: theme.spacing(1.5),
    borderRadius: "4px",
    fontWeight: 500,
    fontSize: "15px",
    textTransform: "none",
    "&.Mui-disabled": {
      backgroundColor: "#bbbbbb",
      color: "#ffffff",
    },
  },

  // Empty cart styles
  emptyCartContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    padding: theme.spacing(3.3, 2),
    marginBottom: theme.spacing(2),
    backgroundColor: "rgba(4, 207, 102, 0.03)",
    borderRadius: "10px",
    border: "1px dashed rgba(4, 207, 102, 0.3)",
  },
  emptyCartIcon: {
    fontSize: "54px",
    color: "rgba(4, 207, 102, 0.7)",
    marginBottom: theme.spacing(2),
  },
  emptyCartText: {
    color: "#444",
    textAlign: "center",
    fontFamily: "'Inter', 'Roboto', 'Helvetica', 'Arial', sans-serif",
    fontWeight: 500,
    marginBottom: theme.spacing(1),
  },
  emptyCartHighlight: {
    color: "#04cf66",
    fontWeight: 600,
  },
  emptyCartSubtext: {
    color: "#666",
    fontSize: "14px",
    textAlign: "center",
    maxWidth: "90%",
    lineHeight: 1.5,
  },
  emptyCartAction: {
    color: "white",
    backgroundColor: "#04cf66",
    fontWeight: 600,
    padding: theme.spacing(1, 3),
    borderRadius: "50px",
    textTransform: "none",
    fontSize: "15px",
    boxShadow: "0 4px 12px rgba(4, 207, 102, 0.25)",
    transition: "transform 0.2s, box-shadow 0.2s",
    fontFamily: "'Poppins', 'Roboto', 'Helvetica', 'Arial', sans-serif",
    "&:hover": {
      backgroundColor: "#03b85a",
      transform: "translateY(-2px)",
      boxShadow: "0 6px 16px rgba(4, 207, 102, 0.3)",
    },
  },

  // Form step styles
  formTitle: {
    marginBottom: theme.spacing(3),
    fontSize: "24px",
    fontWeight: 600,
    position: "relative",
    fontFamily: "'Poppins', 'Roboto', 'Helvetica', 'Arial', sans-serif",
    "&:after": {
      content: '""',
      position: "absolute",
      bottom: "-8px",
      left: "0",
      width: "40px",
      height: "3px",
      backgroundColor: "#04cf66",
    },
  },
  formPaper: {
    padding: theme.spacing(3),
    borderRadius: "12px",
    boxShadow: "0 1px 3px rgba(0,0,0,0.05)",
    background: "#ffffff",
    backgroundImage: `radial-gradient(circle at 90% 10%, rgba(4, 207, 102, 0.03) 0%, rgba(255, 255, 255, 0) 70%)`,
  },
  formContainer: {
    display: "flex",
    flexDirection: "column",
  },
  formField: {
    marginBottom: theme.spacing(1.5),
    "& .MuiOutlinedInput-root": {
      borderRadius: "4px",
    },
    "& .MuiInputLabel-root": {
      fontWeight: 500,
    },
    "& .MuiOutlinedInput-input": {
      padding: "15px 14px",
      [theme.breakpoints.up("md")]: {
        padding: "12px 14px", // Smaller padding in web view
      },
    },
    "&.MuiTextField-root": {
      padding: "2px 6px",
    },
    [theme.breakpoints.up("md")]: {
      marginBottom: theme.spacing(2), // Smaller margin in web view
    },
  },
  formFieldLabel: {
    marginBottom: "5.5px",
    fontWeight: 500,
    fontSize: "14px",
    [theme.breakpoints.up("md")]: {
      marginBottom: theme.spacing(0.5), // Smaller margin in web view
      fontSize: "14px", // Smaller font in web view
    },
  },
  formControl: {
    width: "100%",
    marginBottom: theme.spacing(3),
    "& .MuiInputLabel-root": {
      fontWeight: 500,
    },
    "& .MuiSelect-outlined": {
      padding: "15px 14px",
    },
  },
  formRow: {
    display: "flex",
    flexWrap: "wrap",
    margin: theme.spacing(0, -1),
    "& > *": {
      padding: theme.spacing(0, 1),
      marginBottom: theme.spacing(3),
      [theme.breakpoints.up("sm")]: {
        flex: "0 0 50%",
      },
      [theme.breakpoints.down("xs")]: {
        flex: "0 0 100%",
      },
    },
  },
  submitButton: {
    padding: theme.spacing(1.5),
    backgroundColor: "#04cf66",
    color: "#ffffff",
    "&:hover": {
      backgroundColor: "#03b85a",
    },
    borderRadius: "4px",
    fontWeight: 500,
    fontSize: "16px",
    textTransform: "none",
    marginTop: theme.spacing(1),
    height: "48px",
  },
  backButton: {
    padding: theme.spacing(1.5),
    backgroundColor: "#f5f5f5",
    color: "#000000",
    borderRadius: "4px",
    fontWeight: 500,
    fontSize: "16px",
    textTransform: "none",
    "&:hover": {
      backgroundColor: "#e0e0e0",
    },
    marginRight: theme.spacing(2),
    height: "48px",
  },
  buttonGroup: {
    display: "flex",
    marginTop: theme.spacing(2),
  },
  loadingContainer: {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "rgba(255, 255, 255, 0.8)",
    zIndex: 1000,
  },
  errorSnackbar: {
    backgroundColor: "#ffebee",
    color: "#d32f2f",
  },
  originalPrice: {
    textDecoration: "line-through",
    color: "#9e9e9e",
    marginRight: theme.spacing(1),
    fontSize: "16px",
  },
  // Mobile-specific styles
  stickyBottomBar: {
    position: "fixed",
    bottom: 0,
    left: 0,
    right: 0,
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: theme.spacing(1, 2),
    backgroundColor: "#ffffff",
    boxShadow: "0 -4px 12px rgba(0,0,0,0.1)",
    zIndex: 9999,
    height: theme.spacing(8),
    backgroundImage: `linear-gradient(to right, rgba(4, 207, 102, 0.1), rgba(255, 255, 255, 0.1))`,
    "&:before": {
      content: '""',
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      height: "2px",
      background: "linear-gradient(to right, #04cf66, rgba(4, 207, 102, 0.3))",
    },
    animation: "$slideInFromBottom 0.25s ease", // Ultra-fast animation
  },
  mobileTotal: {
    fontWeight: 600,
    fontSize: "16px",
  },
  mobileTotalAmount: {
    fontSize: "14px",
    color: "#666",
    marginTop: theme.spacing(0.5),
  },
  mobileProceedButton: {
    backgroundColor: "#04cf66",
    color: "#ffffff",
    "&:hover": {
      backgroundColor: "#03b85a",
    },
    fontWeight: 600,
    textTransform: "none",
    "&.Mui-disabled": {
      backgroundColor: "#bbbbbb",
      color: "#ffffff",
    },
    padding: theme.spacing(1.2, 3),
    borderRadius: "6px",
    transition: "transform 0.2s, box-shadow 0.2s",
    boxShadow: "0 2px 8px rgba(4, 207, 102, 0.3)",
    "&:active": {
      transform: "scale(0.98)",
    },
    animation: "$pulseGreen 2s infinite",
  },
  summaryAccordion: {
    boxShadow: "none",
    backgroundColor: "transparent",
    "&::before": {
      display: "none",
    },
    margin: theme.spacing(2, 0, 3),
    position: "relative",
    "&:after": {
      content: '""',
      position: "absolute",
      bottom: 0,
      left: "10%",
      width: "80%",
      height: "1px",
      background:
        "linear-gradient(to right, rgba(4, 207, 102, 0), rgba(4, 207, 102, 0.3), rgba(4, 207, 102, 0))",
    },
  },
  summaryAccordionHeader: {
    fontWeight: 600,
    fontSize: "16px",
    color: "#04cf66",
    fontFamily: "'Poppins', 'Roboto', 'Helvetica', 'Arial', sans-serif",
  },
  summaryAccordionContent: {
    padding: 0,
  },
  mobileFormContainer: {
    paddingBottom: theme.spacing(6), // Increased for sticky elements
    paddingTop: theme.spacing(2),
  },
  greenText: {
    color: "#04cf66",
  },
  dubaiFlair: {
    position: "absolute",
    bottom: 0,
    left: 0,
    right: 0,
    height: "80px",
    background: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1200 100' preserveAspectRatio='none'%3E%3Cpath fill='%23f0f9f1' d='M0,0 L0,100 L1200,100 L1200,0 L0,0 Z M150,95 L130,95 L130,80 L150,80 L150,95 Z M190,95 L170,95 L170,75 L190,75 L190,95 Z M230,95 L210,95 L210,70 L230,70 L230,95 Z M350,95 L330,95 L330,40 L350,40 L350,95 Z M370,40 L370,95 L390,95 L390,40 L370,40 Z M370,30 L370,35 L380,25 L390,35 L390,30 L380,20 L370,30 Z M520,95 L500,95 L500,60 L520,60 L520,95 Z M540,60 L560,60 L560,95 L540,95 L540,60 Z M700,95 L650,95 L650,50 L700,50 L700,95 Z M725,95 L725,40 L725,30 L700,20 L675,30 L675,40 L675,95 L725,95 Z M800,95 L780,95 L780,60 L800,60 L800,95 Z M880,95 L860,95 L860,85 L880,85 L880,95 Z M900,95 L900,70 L920,70 L920,95 L900,95 Z M1050,95 L1000,95 L1000,30 L1025,5 L1050,30 L1050,95 Z'/%3E%3C/svg%3E") repeat-x bottom center`,
    backgroundSize: "cover",
    zIndex: 0,
    opacity: 0.5,
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
  },
  // Update icon styles for custom SVG icons
  iconWrapper: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginRight: theme.spacing(1),
    color: "inherit",
  },
  customIcon: {
    color: "inherit",
    verticalAlign: "middle",
    marginRight: theme.spacing(1),
  },
  // Add urgency elements styling
  urgencyBadge: {
    display: "inline-flex",
    alignItems: "center",
    padding: "6px 14px",
    borderRadius: "20px",
    backgroundColor: "#ffebee",
    color: "#d32f2f",
    fontSize: "15px",
    fontWeight: 600,
    "& svg": {
      marginRight: theme.spacing(0.5),
      fontSize: "16px",
      width: "16px",
      height: "16px",
      fontWeight: 600,
    },
  },

  pulsingDot: {
    height: "10px",
    width: "10px",
    backgroundColor: "#d32f2f",
    borderRadius: "50%",
    display: "inline-block",
    marginRight: "12px",
    animation: "$pulse 1.5s infinite",
  },

  socialProofContainer: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(2),
    padding: theme.spacing(1.5),
    backgroundColor: "rgba(4, 207, 102, 0.08)",
    borderRadius: "6px",
    border: "1px dashed rgba(4, 207, 102, 0.3)",
  },

  registrationCounter: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    margin: theme.spacing(1, 0),
    "& svg": {
      color: "#04cf66",
      marginRight: theme.spacing(1),
    },
  },

  timeLeftContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginTop: theme.spacing(1),
    "& svg": {
      color: "#d32f2f",
      marginRight: theme.spacing(0.5),
    },
  },

  "@keyframes pulse": {
    "0%": {
      transform: "scale(0.95)",
      boxShadow: "0 0 0 0 rgba(211, 47, 47, 0.7)",
    },
    "70%": {
      transform: "scale(1)",
      boxShadow: "0 0 0 8px rgba(211, 47, 47, 0)",
    },
    "100%": {
      transform: "scale(0.95)",
      boxShadow: "0 0 0 0 rgba(211, 47, 47, 0)",
    },
  },

  remainingSpots: {
    backgroundColor: "#FFF8E1",
    color: "#FF9800",
    padding: theme.spacing(0.25, 0.75),
    borderRadius: "4px",
    fontSize: "11px",
    fontWeight: 600,
    display: "inline-flex",
    alignItems: "center",
    marginLeft: theme.spacing(1),
    "& svg": {
      fontSize: "12px",
      marginRight: "2px",
    },
  },

  almostGone: {
    backgroundColor: "#FFEBEE",
    color: "#D32F2F",
  },

  testimonialCard: {
    backgroundColor: "#fff",
    border: "1px solid #e0e0e0",
    borderRadius: "8px",
    padding: theme.spacing(2),
    marginBottom: theme.spacing(2),
    position: "relative",
    boxShadow: "0 2px 4px rgba(0,0,0,0.05)",
    "& .MuiAvatar-root": {
      width: 36,
      height: 36,
      border: "2px solid #fff",
      boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
    },
  },

  testimonialQuote: {
    fontStyle: "italic",
    fontSize: "14px",
    color: "#555",
    margin: theme.spacing(1, 0),
    paddingLeft: theme.spacing(1),
    borderLeft: "2px solid rgba(4, 207, 102, 0.3)",
  },

  testimonialAuthor: {
    display: "flex",
    alignItems: "center",
    marginTop: theme.spacing(1),
  },

  testimonialName: {
    marginLeft: theme.spacing(1),
    fontSize: "13px",
    fontWeight: 600,
  },

  testimonialCompany: {
    fontSize: "12px",
    color: "#757575",
  },

  // Enhanced mobile styles
  floatingBadge: {
    position: "fixed",
    top: theme.spacing(2),
    right: theme.spacing(2),
    zIndex: 999,
    backgroundColor: "#d32f2f",
    color: "#fff",
    padding: theme.spacing(0.5, 1.5),
    borderRadius: "20px",
    fontSize: "12px",
    fontWeight: 600,
    boxShadow: "0 2px 8px rgba(0,0,0,0.2)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    [theme.breakpoints.up("md")]: {
      display: "none",
    },
  },

  // Add countdown timer for mobile
  countdownTimer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: theme.spacing(0.5),
  },

  countdownUnit: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: theme.spacing(0.5),
    minWidth: "36px",
  },

  countdownNumber: {
    backgroundColor: "#1a1a1a",
    color: "#fff",
    padding: theme.spacing(0.5, 1),
    borderRadius: "4px",
    fontWeight: "bold",
    fontSize: "14px",
  },

  countdownLabel: {
    fontSize: "10px",
    marginTop: "2px",
  },
  countryCodeSelector: {
    position: "relative",
    marginRight: theme.spacing(2),
    cursor: "pointer",
    "&:hover": {
      backgroundColor: "#f0f9f1",
    },
  },
  // Add these additional styles for the integrated phone input
  countryCodeInput: {
    display: "flex",
    alignItems: "center",
    backgroundColor: "#f9f9f9",
    borderRadius: "4px 0 0 4px",
    padding: "0 8px",
    height: "100%",
    cursor: "pointer",
    borderRight: "1px solid #e0e0e0",
    "&:hover": {
      backgroundColor: "#f0f9f1",
    },
  },
  phoneInputContainer: {
    display: "flex",
    alignItems: "center",
    "& .MuiOutlinedInput-root": {
      borderRadius: "4px",
      "& .MuiOutlinedInput-notchedOutline": {
        borderRadius: "4px",
      },
    },
    "& .MuiOutlinedInput-adornedStart": {
      paddingLeft: "0px",
    },
    "& .MuiOutlinedInput-input": {
      paddingLeft: "8px",
    },
  },
  mobileMenuPaper: {
    maxHeight: "40vh",
    "& .MuiMenuItem-root": {
      minHeight: "40px",
      padding: "4px 16px",
    },
    "& .MuiListItem-root": {
      minHeight: "40px",
      padding: "4px 16px",
    },
  },
  mobileAutocompletePaper: {
    maxHeight: "40vh",
    marginTop: "5px",
    marginBottom: "5px",
    "& .MuiAutocomplete-option": {
      minHeight: "40px",
      padding: "4px 16px",
    },
  },
  radioGroup: {
    display: "flex",
    flexWrap: "wrap",
    gap: "10px",
    marginBottom: theme.spacing(1.5),
    [theme.breakpoints.up("md")]: {
      marginBottom: theme.spacing(2),
    },
  },
  radioButton: {
    flex: "0 0 calc(50% - 5px)",
    margin: 0,
    [theme.breakpoints.down("xs")]: {
      flex: "0 0 100%",
    },
  },
  radioLabel: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    width: "92%",
    padding: "8px 12px",
    border: "1px solid #e0e0e0",
    borderRadius: "4px",
    transition: "all 0.2s ease",
    cursor: "pointer",
    "&:hover": {
      backgroundColor: "#f9f9f9",
      borderColor: "#cccccc",
    },
  },
  radioLabelSelected: {
    backgroundColor: "#f0f9f1",
    borderColor: "#04cf66",
    "& .MuiFormControlLabel-label": {
      fontWeight: 500,
    },
  },
  radioRoot: {
    padding: "0",
    marginRight: "8px",
    color: "#04cf66",
  },
  radioErrorText: {
    color: "#f44336",
    fontSize: "12px",
    marginTop: "4px",
    marginLeft: "14px",
  },

  // Add a green pulse animation just for the button
  "@keyframes pulseGreen": {
    "0%": {
      transform: "scale(0.95)",
      boxShadow: "0 0 0 0 rgba(4, 207, 102, 0.7)",
    },
    "70%": {
      transform: "scale(1)",
      boxShadow: "0 0 0 8px rgba(4, 207, 102, 0)",
    },
    "100%": {
      transform: "scale(0.95)",
      boxShadow: "0 0 0 0 rgba(4, 207, 102, 0)",
    },
  },

  // Ultra-fast slide-in animation
  "@keyframes slideInFromBottom": {
    "0%": {
      transform: "translateY(30%)", // Reduced distance for faster appearance
      opacity: 0.5, // Start with higher opacity for faster fade-in
    },
    "100%": {
      transform: "translateY(0)",
      opacity: 1,
    },
  },

  // Ultra-fast summary expansion animation
  "@keyframes expandSummary": {
    "0%": {
      maxHeight: "0",
      opacity: 0.5, // Start with higher opacity for faster fade-in
      transform: "translateY(5px)", // Minimal distance for faster appearance
    },
    "100%": {
      maxHeight: "60vh",
      opacity: 1,
      transform: "translateY(0)",
    },
  },

  // Add a disappearing animation keyframe
  "@keyframes collapseSummary": {
    "0%": {
      maxHeight: "60vh",
      opacity: 1,
      transform: "translateY(0)",
    },
    "100%": {
      maxHeight: "0",
      opacity: 0.5,
      transform: "translateY(5px)",
    },
  },
}));

// Validation functions
const validateEmail = (email) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};

const validatePhone = (phone) => {
  const phoneRegex = /^[0-9]+$/;
  return phoneRegex.test(phone.replace(/\D/g, ""));
};

// Organization size options
const organizationSizes = [
  "1-10 employees",
  "10-20 employees",
  "20-50 employees",
  "50-200 employees",
  "200+ employees",
];

// Industry options
const industries = [
  "Real Estate",
  "Technology",
  "Finance",
  "Healthcare",
  "Education",
  "E-commerce",
  "Manufacturing",
  "Professional Services",
  "Marketing",
  "Media",
  "Telecommunications",
  "Travel",
  "Government & Public Sector",
  "Non-Profit",
  "Others",
];

// Pass features - these would likely come from your API
const silverPassSingle = [
  "Access to All Sessions",
  "Lunch + High Tea",
  "Networking with Industry Leaders",
];

const silverPassMulti = [
  "Full-Day Event Pass",
  "Lunch + High Tea",
  "Networking with Founders, Marketers & Tech Leaders",
];

// Update Gold Pass Single features that may contain the currency symbol
const goldPassSingle = [
  "Access to Full-Day Event with Lunch, High Tea & Networking (Worth AED 2000)",
  "1:1 Consultation with AiSensy's WhatsApp Experts (Worth AED 1000)",
  "AiSensy Premium Plan – 1 Month Access (Worth AED 300)",
  "Click-to-WhatsApp Ads Credit (Worth AED 350)",
];

// Update Gold Pass Multi features that may contain the currency symbol
const goldPassMulti = [
  "Full-Day Event Pass (Worth AED 2000)",
  "Lunch + High Tea + Networking",
  "1:1 Consultation with AiSensy (Worth AED 1000)",
  "AiSensy Plan – 3 Months Access (Worth AED 900)",
  "Click-to-WhatsApp Ads Credit (Worth AED 350)",
];

function AiSensyPaymentPage() {
  const classes = useStyles();
  const theme = useTheme();
  const { id } = useParams();
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down("sm"));
  const [activeStep, setActiveStep] = useState(0);
  const [loading, setLoading] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState(null);
  const [showError, setShowError] = useState(false);
  const [summaryExpanded, setSummaryExpanded] = useState(false);

  // Add these global dropdown props
  const menuProps = {
    anchorOrigin: {
      vertical: "top",
      horizontal: "left",
    },
    transformOrigin: {
      vertical: "bottom",
      horizontal: "left",
    },
    getContentAnchorEl: null,
  };

  // Define custom popper for upward-opening dropdowns
  const CustomPopper = (props) => (
    <Popper
      {...props}
      placement="top-start"
      modifiers={{
        flip: {
          enabled: false,
        },
        preventOverflow: {
          enabled: true,
          boundariesElement: "window",
        },
      }}
    />
  );

  // Add these to the useState declarations
  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    phone: "",
    organizationName: "",
    organizationSize: "",
    industry: "",
  });

  // Order state
  const [couponCode, setCouponCode] = useState("");
  const [couponApplied, setCouponApplied] = useState(false);
  const [discount, setDiscount] = useState(0);
  const [validatingCoupon, setValidatingCoupon] = useState(false);
  const [couponMessage, setCouponMessage] = useState("");
  const [currencySymbol, setCurrencySymbol] = useState("AED ");

  const [validationErrors, setValidationErrors] = useState({
    fullName: "",
    email: "",
    phone: "",
    organizationName: "",
    organizationSize: "",
    industry: "",
  });
  const [couponData, setCouponData] = useState(null);

  // Add states for urgency elements
  const [timeLeft, setTimeLeft] = useState({ days: 3, hours: 14, minutes: 22 });
  const [registrationCount, setRegistrationCount] = useState(142);
  const [availableSpots, setAvailableSpots] = useState({
    "Silver Pass - Single Member": 3,
    "Silver pass - Multi Member": 6,
    "Gold Pass - Single Member": 4,
    "Gold Pass - Multi Member": 3,
  });

  // Add state for country code
  const [selectedCountry, setSelectedCountry] = useState({
    code: "AE",
    dial_code: "+971",
    name: "United Arab Emirates",
    flag: "🇦🇪",
  });

  // Add this at the end of the component return, just before the final closing div - remove the tooltip code if it exists
  const [quantityMsg, setQuantityMsg] = useState("");
  const [showQuantityMsg, setShowQuantityMsg] = useState(false);

  useEffect(() => {
    document.title = "AiSensy Checkout";

    // Create a MutationObserver to monitor title changes
    const titleObserver = new MutationObserver(() => {
      if (document.title !== "AiSensy Checkout") {
        document.title = "AiSensy Checkout";
      }
    });

    titleObserver.observe(document.querySelector("title"), {
      childList: true,
      characterData: true,
      subtree: true,
    });

    return () => {
      titleObserver.disconnect();
    };
  }, []);

  // Event details
  const [eventData, setEventData] = useState({
    title: "EVOLVE'25 : Dubai AI Edition",
    dateTime: "Apr 25th, 2025 | 9:00AM - 6:00PM",
    location: "Millennium Plaza Downtown Hotel, Dubai",
  });

  // Pass options
  const [passes, setPasses] = useState([
    {
      id: "single",
      title: "Silver Pass - Single Member",
      description:
        "Access to Exclusive Full day event with Lunch, High Tea & Networking worth AED 2000",
      price: 250,
      originalPrice: 250,
      features: silverPassSingle,
      quantity: 0,
    },
    {
      id: "multi",
      title: "Silver pass - Multi Member",
      description:
        "Attend the event for just AED 199 per member for 2 or more members :",
      price: 199,
      originalPrice: 199,
      features: silverPassMulti,
      quantity: 0,
    },
    {
      id: "single",
      title: "Gold Pass - Single Member",
      description:
        "Get value worth AED 3650 at just AED 750 per person included :",
      price: 750,
      features: goldPassSingle,
      quantity: 0,
    },
    {
      id: "multi",
      title: "Gold Pass - Multi Member",
      description:
        "Everything in the above pass for just AED 699 per member for 2 or more members :",
      price: 699,
      features: goldPassMulti,
      quantity: 0,
    },
  ]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
    // Clear validation error when user types
    setValidationErrors((prev) => ({
      ...prev,
      [name]: "",
    }));
  };

  const validateForm = () => {
    const errors = {};
    let isValid = true;

    if (!formData.fullName.trim()) {
      errors.fullName = "Full name is required";
      isValid = false;
    }

    if (!formData.email) {
      errors.email = "Email is required";
      isValid = false;
    } else if (!validateEmail(formData.email)) {
      errors.email = "Please enter a valid email address";
      isValid = false;
    }

    if (!formData.phone) {
      errors.phone = "Phone number is required";
      isValid = false;
    } else if (!validatePhone(formData.phone)) {
      errors.phone = "Please enter a valid phone number";
      isValid = false;
    }

    if (!formData.organizationName.trim()) {
      errors.organizationName = "Organization name is required";
      isValid = false;
    }

    if (!formData.organizationSize) {
      errors.organizationSize = "Organization size is required";
      isValid = false;
    }

    setValidationErrors(errors);
    return isValid;
  };

  const handleCloseError = () => {
    setShowError(false);
  };

  const handleCloseQuantityMsg = () => {
    setShowQuantityMsg(false);
  };

  const handleCouponChange = (e) => {
    const upperCaseValue = e.target.value.toUpperCase();
    setCouponCode(upperCaseValue);
    if (couponApplied) {
      setCouponApplied(false);
      setDiscount(0);
      setCouponMessage("");
    }
  };

  const handleApplyCoupon = async () => {
    if (!couponCode.trim()) {
      setCouponMessage("Please enter a coupon code");
      return;
    }

    setValidatingCoupon(true);
    setCouponMessage("");

    try {
      // Call the verify-coupon API to check if the coupon is valid
      const response = await axios.post(
        `${INTEGRATION_SERVER_URL}/coupons/t1/verify`,
        {
          couponCode,
          amount: getSubtotal(),
        }
      );

      if (response.data.success) {
        // If verification is successful, store the coupon info
        setCouponApplied(true);

        // Store coupon data for later use
        const couponInfo = response.data.data;
        setCouponData(couponInfo);

        // Calculate discount amount based on discountType and discountValue
        let discountAmount = 0;
        const subtotal = getSubtotal();

        if (couponInfo.discountType === "percentage") {
          // Calculate percentage discount and round to 2 decimal places
          discountAmount = parseFloat(
            (subtotal * (couponInfo.discountValue / 100)).toFixed(2)
          );
        } else if (couponInfo.discountType === "fixed") {
          // Apply fixed discount
          discountAmount = parseFloat(couponInfo.discountValue.toFixed(2));
        }

        // Ensure discount doesn't exceed subtotal
        discountAmount = parseFloat(
          Math.min(discountAmount, subtotal).toFixed(2)
        );

        setDiscount(discountAmount);
        setCouponMessage("Coupon verified successfully!");
      } else {
        setCouponApplied(false);
        setDiscount(0);
        setCouponData(null);
        setCouponMessage(response.data.message || "Invalid coupon code");
      }
    } catch (err) {
      console.error("Coupon verification error:", err);
      setCouponApplied(false);
      setDiscount(0);
      setCouponData(null);
      setCouponMessage(
        err.response?.data?.message || "Failed to verify coupon"
      );
    } finally {
      setValidatingCoupon(false);
    }
  };

  const handleQuantityChange = (passId, change, passTitle = "") => {
    setPasses((prevPasses) => {
      // Create a new array to avoid mutation issues
      const updatedPasses = prevPasses.map((pass) => {
        // Match by both ID and title to handle multiple passes with same ID
        if (
          pass.id === passId &&
          (passTitle === "" || pass.title === passTitle)
        ) {
          // Calculate new quantity
          let newQuantity = pass.quantity + change;

          // Handle single pass quantity limit
          if (pass.title.includes("Single") && newQuantity > 1) {
            setQuantityMsg(
              "Only 1 seat allowed for Single Pass. Switch to Multi-Member Pass for 2+ seats."
            );
            setShowQuantityMsg(true);
            return pass; // Don't change quantity
          }

          // If this is multi pass and we're increasing from 0, start at 2
          if (
            pass.title.includes("Multi") &&
            pass.quantity === 0 &&
            change > 0
          ) {
            newQuantity = 2;
          }

          // If this is multi pass and we're decreasing to 1, set to 0
          if (
            pass.title.includes("Multi") &&
            pass.quantity > 1 &&
            newQuantity === 1
          ) {
            newQuantity = 0;
          }

          // Don't allow negative quantities
          if (newQuantity < 0) {
            newQuantity = 0;
          }

          // Return updated pass
          return {
            ...pass,
            quantity: newQuantity,
          };
        }
        return pass;
      });

      // If coupon is applied, recalculate discount based on new passes state
      if (couponApplied && couponData) {
        const newSubtotal = getSubtotalFromPasses(updatedPasses);

        // Recalculate discount based on stored coupon data
        let newDiscount = 0;

        if (couponData.discountType === "percentage") {
          // Calculate percentage discount with proper decimal formatting
          newDiscount = parseFloat(
            (newSubtotal * (couponData.discountValue / 100)).toFixed(2)
          );
        } else if (couponData.discountType === "fixed") {
          // Apply fixed discount, capped at subtotal, with proper decimal formatting
          newDiscount = parseFloat(
            Math.min(couponData.discountValue, newSubtotal).toFixed(2)
          );
        }

        setDiscount(newDiscount);
      }

      return updatedPasses;
    });
  };

  // Helper function to calculate subtotal from a passes array
  const getSubtotalFromPasses = (passesArray) => {
    return parseFloat(
      passesArray
        .reduce((total, pass) => total + (pass.price * pass.quantity || 0), 0)
        .toFixed(2)
    );
  };

  // Calculate amounts
  const getSubtotal = () => {
    return parseFloat(
      passes
        .reduce((total, pass) => total + (pass.price * pass.quantity || 0), 0)
        .toFixed(2)
    );
  };

  const getTotalAmount = () => {
    const subtotal = getSubtotal();
    // Ensure the result is not negative and round to 2 decimal places
    return parseFloat(Math.max(0, subtotal - discount).toFixed(2));
  };

  // Check if cart has any items
  const hasItems = () => {
    return passes.some((pass) => pass.quantity > 0);
  };

  // Add Meta Pixel tracking code
  useEffect(() => {
    // Create and inject Facebook Pixel script
    const injectPixelScript = () => {
      // Check if script already exists to avoid duplicates
      if (document.getElementById("fb-pixel")) return;

      // Create script element
      const script = document.createElement("script");
      script.id = "fb-pixel";
      script.innerHTML = `
        !function(f,b,e,v,n,t,s)
        {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
        n.callMethod.apply(n,arguments):n.queue.push(arguments)};
        if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
        n.queue=[];t=b.createElement(e);t.async=!0;
        t.src=v;s=b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t,s)}(window, document,'script',
        'https://connect.facebook.net/en_US/fbevents.js');
        fbq('init', '255162156131712');
        fbq('track', 'PageView');
      `;

      // Add script to document head
      document.head.appendChild(script);

      // Add noscript pixel for browsers with JavaScript disabled
      const noscript = document.createElement("noscript");
      const img = document.createElement("img");
      img.height = "1";
      img.width = "1";
      img.style.display = "none";
      img.src =
        "https://www.facebook.com/tr?id=255162156131712&ev=PageView&noscript=1";
      noscript.appendChild(img);
      document.head.appendChild(noscript);
    };

    // Call the function to inject pixel
    injectPixelScript();

    // Clean up function to remove the scripts when component unmounts
    return () => {
      const pixelScript = document.getElementById("fb-pixel");
      if (pixelScript) pixelScript.remove();

      // Also remove noscript element if exists
      const noscriptElements = document.head.getElementsByTagName("noscript");
      if (noscriptElements.length > 0) {
        for (let i = 0; i < noscriptElements.length; i++) {
          if (noscriptElements[i].innerHTML.includes("255162156131712")) {
            noscriptElements[i].remove();
          }
        }
      }
    };
  }, []); // Empty dependency array means this effect runs once on mount

  // Add this function near other API call functions
  const sendFormDataToBackend = async (formDataWithCode) => {
    try {
      await axios.post(
        `${INTEGRATION_SERVER_URL}/xpay/t1/submit-form`,
        formDataWithCode
      );
      console.log("Form data sent to backend successfully");
    } catch (error) {
      console.error("Error sending form data to backend:", error);
    }
  };

  const handleProceed = () => {
    if (activeStep === 0) {
      // First step - validate form before proceeding
      if (!validateForm()) {
        return;
      }

      const formDataWithCountryCode = {
        ...formData,
        phone: `${selectedCountry.dial_code}${formData.phone}`,
      };

      sendFormDataToBackend(formDataWithCountryCode);

      if (window.fbq) {
        window.fbq("track", "Lead", {
          content_name: eventData.title,
          content_category: "Event Registration",
        });
      }

      setActiveStep(1);

      // Scroll to top when changing to step 2
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    } else {
      // Second step - verify passes selection before payment
      const totalItems = passes.reduce((sum, pass) => sum + pass.quantity, 0);
      if (totalItems === 0) {
        setError("Please select at least one pass to continue");
        setShowError(true);
        return;
      }
      handleSubmit();
    }
  };

  // Update handleBack to return to form from passes
  const handleBack = () => {
    setActiveStep(0);
  };

  // Update handleSubmit to handle submission without form event
  const handleSubmit = async (e) => {
    if (e) e.preventDefault();

    // Check if passes are selected
    const totalItems = passes.reduce((sum, pass) => sum + pass.quantity, 0);
    const cartTotal = getSubtotal();

    if (totalItems === 0) {
      setError("Please select at least one pass to continue");
      setShowError(true);
      return;
    }

    // Prepare the data for submission
    const selectedPasses = passes.filter((pass) => pass.quantity > 0);
    const orderDetails = selectedPasses.map((pass) => ({
      id: pass.id,
      title: pass.title,
      price: pass.price,
      quantity: pass.quantity,
    }));

    setSubmitting(true);

    try {
      // If a coupon is verified, apply it now
      if (couponApplied && couponCode.trim() && couponData) {
        try {
          const applyCouponResponse = await axios.post(
            `${INTEGRATION_SERVER_URL}/coupons/t1/apply`,
            {
              couponCode,
              amount: getSubtotal(),
              currency: "AED", // Always using AED for Dubai page
              discountType: couponData.discountType,
              discountValue: couponData.discountValue,
            }
          );

          if (applyCouponResponse.data.success) {
            console.log("Coupon applied successfully:", {
              couponCode,
            });
          } else {
            console.error("Failed to apply coupon:", {
              couponCode,
              message: applyCouponResponse.data.message,
            });
            setCouponApplied(false);
            setDiscount(0);
            setCouponMessage(
              applyCouponResponse.data.message || "Unable to apply coupon"
            );
            setCouponData(null);
            return;
          }
        } catch (couponError) {
          console.error("Error applying coupon:", couponError);
          setCouponApplied(false);
          setDiscount(0);
          setCouponMessage(
            couponError.response?.data?.message || "Failed to apply coupon"
          );
          return;
        }
      }

      const paymentFormData = {
        ...formData,
        phone: formData.phone.startsWith("+")
          ? formData.phone
          : `${selectedCountry.dial_code}${formData.phone}`,
      };

      const paymentData = {
        ...paymentFormData,
        passes: orderDetails,
        couponCode: couponApplied ? couponCode : "",
      };

      const { data } = await axios.post(
        `${INTEGRATION_SERVER_URL}/xpay/t1/create-intent`,
        paymentData
      );

      if (data.data && data.data.status === "CREATED") {
        window.location.href = data.data.fwdUrl;
      }
    } catch (error) {
      setError(
        error.response?.data?.message || "Failed to create payment intent"
      );
      setShowError(true);
    } finally {
      setSubmitting(false);
    }
  };

  // Create a common header component that appears on both steps
  const renderHeader = () => {
    return (
      <>
        <Box className={classes.headerLogo}>
          <img src={AiSensyLogo} alt="AiSensy Logo" className={classes.logo} />
        </Box>

        <Typography variant="h5" className={classes.eventTitle}>
          EVOLVE<span className={classes.greenText}>'25</span> : Dubai AI
          Edition
        </Typography>

        {!isMobile && (
          <Box className={classes.eventBadges}>
            <Chip
              icon={
                <MapPinIcon
                  className={classes.customIcon}
                  style={{ marginRight: "-4px" }}
                />
              }
              label="Dubai"
              className={classes.dubaiChip}
              size="small"
            />
            <Chip
              icon={
                <MessageSquareIcon
                  className={classes.customIcon}
                  style={{ marginRight: "-4px" }}
                />
              }
              label="WhatsApp"
              className={classes.whatsappChip}
              size="small"
            />
            <Chip
              icon={
                <GlobeIcon
                  className={classes.customIcon}
                  style={{ marginRight: "-4px" }}
                />
              }
              label="AI"
              className={classes.aiChip}
              size="small"
            />
            <Chip
              icon={
                <BriefcaseIcon
                  className={classes.customIcon}
                  style={{ marginRight: "-4px" }}
                />
              }
              label="Business"
              className={classes.businessChip}
              size="small"
            />
          </Box>
        )}
        <Typography variant="body2" className={classes.eventDate}>
          <MapPinIcon className={classes.customIcon} />
          <span className={classes.eventDateText}>{eventData.location}</span>
        </Typography>

        {activeStep === 1 && <Box mt={0.1}></Box>}

        <Typography variant="body2" className={classes.eventDate}>
          <CalendarIcon className={classes.customIcon} />
          <span className={classes.eventDateText}>{eventData.dateTime}</span>
        </Typography>
      </>
    );
  };

  // Render the form step (now the first step)
  const renderUserDetailsStep = () => {
    return (
      <Container
        maxWidth="lg"
        className={isMobile ? classes.mobileFormContainer : ""}
      >
        {/* Add floating countdown for mobile */}
        {isMobile && (
          <Box className={classes.floatingBadge}>
            <AccessTimeIcon fontSize="small" style={{ marginRight: "4px" }} />
            Limited offer ends soon!
          </Box>
        )}

        {/* Display side by side on desktop, stacked on mobile */}
        <Grid container spacing={3}>
          {/* Header section - full width on mobile, left side on desktop */}
          <Grid item xs={12} md={5}>
            {renderHeader()}

            {/* Add urgency badge with real countdown */}
            {isMobile && (
              <Box display="flex" justifyContent="center" mt={2}>
                <Box className={classes.urgencyBadge}>
                  <span className={classes.pulsingDot}></span>
                  {timeLeft.days > 0 ? (
                    <Typography
                      variant="body2"
                      style={{ fontSize: 13, fontWeight: 600 }}
                    >
                      Final Countdown: {timeLeft.days}d {timeLeft.hours}h{" "}
                      {timeLeft.minutes}m
                    </Typography>
                  ) : (
                    <Typography
                      variant="body2"
                      style={{ fontSize: 13, fontWeight: 600 }}
                    >
                      LAST DAY TO REGISTER! Only {timeLeft.hours}h{" "}
                      {timeLeft.minutes}m left
                    </Typography>
                  )}
                </Box>
              </Box>
            )}
          </Grid>

          {/* Form section - full width on mobile, right side on desktop */}
          <Grid item xs={12} md={7}>
            <Box display="flex" alignItems="center">
              <Typography variant="h5" className={classes.formTitle}>
                Secure Your Spot Now
              </Typography>
              {/* <Box className={classes.limitedSpotsBadge}>
                <WarningIcon fontSize="small" />
                Limited seats available
              </Box> */}
            </Box>

            <Typography variant="body2" className={classes.formFieldLabel}>
              Name*
            </Typography>
            <TextField
              fullWidth
              variant="outlined"
              required
              placeholder="Enter your full name"
              name="fullName"
              value={formData.fullName}
              onChange={handleChange}
              className={classes.formField}
              error={!!validationErrors.fullName}
              helperText={validationErrors.fullName}
              InputLabelProps={{ shrink: false }}
            />

            <Typography variant="body2" className={classes.formFieldLabel}>
              Email Address*
            </Typography>
            <TextField
              fullWidth
              variant="outlined"
              required
              type="email"
              placeholder="Enter your email address"
              name="email"
              value={formData.email}
              onChange={handleChange}
              className={classes.formField}
              error={!!validationErrors.email}
              helperText={validationErrors.email}
              InputLabelProps={{ shrink: false }}
            />

            <Box position="relative">
              <Typography variant="body2" className={classes.formFieldLabel}>
                Phone Number*
              </Typography>
              <Box className={classes.phoneInputContainer}>
                <TextField
                  fullWidth
                  variant="outlined"
                  required
                  placeholder="Enter your phone number"
                  name="phone"
                  value={formData.phone}
                  onChange={(e) => {
                    const numericValue = e.target.value.replace(/[^0-9]/g, "");
                    handleChange({
                      target: {
                        name: "phone",
                        value: numericValue,
                      },
                    });
                  }}
                  className={classes.formField}
                  error={!!validationErrors.phone}
                  helperText={validationErrors.phone}
                  InputLabelProps={{ shrink: false }}
                  type="tel"
                  inputProps={{
                    inputMode: "numeric",
                    pattern: "[0-9]*",
                  }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment
                        position="start"
                        style={{ marginRight: 0 }}
                      >
                        <Box
                          className={classes.countryCodeInput}
                          style={{ cursor: "pointer" }}
                        >
                          <Select
                            id="countrySelect"
                            value={selectedCountry.code}
                            onChange={(e) => {
                              const country = countries.find(
                                (c) => c.code === e.target.value
                              );
                              setSelectedCountry(country);
                              const phoneWithoutCode = formData.phone.replace(
                                /^\+\d+/,
                                ""
                              );
                              handleChange({
                                target: {
                                  name: "phone",
                                  value: phoneWithoutCode,
                                },
                              });
                            }}
                            displayEmpty
                            renderValue={() => (
                              <Box display="flex" alignItems="center">
                                <span style={{ marginRight: 4, fontSize: 18 }}>
                                  {selectedCountry.flag}
                                </span>
                                <span
                                  style={{
                                    fontSize: 14,
                                    fontWeight: 500,
                                    color: "#333",
                                    marginRight: 4,
                                  }}
                                >
                                  {selectedCountry.dial_code}
                                </span>
                              </Box>
                            )}
                            MenuProps={{
                              anchorOrigin: {
                                vertical: "bottom",
                                horizontal: "left",
                              },
                              transformOrigin: {
                                vertical: "top",
                                horizontal: "left",
                              },
                              getContentAnchorEl: null,
                              PaperProps: {
                                className: classes.mobileMenuPaper,
                              },
                              disableRestoreFocus: true,
                            }}
                            style={{
                              width: "auto",
                              height: "100%",
                              padding: "0",
                              border: "none",
                              boxShadow: "none", // Remove any box shadow
                            }}
                            disableUnderline={true} // Remove underline that might cause shadow effect
                          >
                            {countries.map((country) => (
                              <MenuItem
                                key={country.code}
                                value={country.code}
                                style={{ minHeight: "40px" }}
                              >
                                <Box display="flex" alignItems="center">
                                  <span
                                    style={{ marginRight: 8, fontSize: 18 }}
                                  >
                                    {country.flag}
                                  </span>
                                  <span style={{ fontSize: 14 }}>
                                    {country.name}
                                  </span>
                                  <span
                                    style={{
                                      marginLeft: 8,
                                      color: "#666",
                                      fontSize: 14,
                                    }}
                                  >
                                    {country.dial_code}
                                  </span>
                                </Box>
                              </MenuItem>
                            ))}
                          </Select>
                        </Box>
                      </InputAdornment>
                    ),
                  }}
                />
              </Box>
            </Box>

            <Typography variant="body2" className={classes.formFieldLabel}>
              Organisation Name*
            </Typography>
            <TextField
              fullWidth
              variant="outlined"
              required
              placeholder="Enter your organization name"
              name="organizationName"
              value={formData.organizationName}
              onChange={handleChange}
              className={classes.formField}
              error={!!validationErrors.organizationName}
              helperText={validationErrors.organizationName}
              InputLabelProps={{ shrink: false }}
            />

            <Typography variant="body2" className={classes.formFieldLabel}>
              Your Organisation Size*
            </Typography>
            <Box className={classes.radioGroup}>
              {organizationSizes.map((size) => (
                <Box key={size} className={classes.radioButton}>
                  <label
                    className={`${classes.radioLabel} ${
                      formData.organizationSize === size
                        ? classes.radioLabelSelected
                        : ""
                    }`}
                  >
                    <Radio
                      checked={formData.organizationSize === size}
                      onChange={() =>
                        handleChange({
                          target: {
                            name: "organizationSize",
                            value: size,
                          },
                        })
                      }
                      className={classes.radioRoot}
                      color="primary"
                      size="small"
                    />
                    <Typography variant="body2">{size}</Typography>
                  </label>
                </Box>
              ))}
            </Box>
            {validationErrors.organizationSize && (
              <Typography className={classes.radioErrorText}>
                {validationErrors.organizationSize}
              </Typography>
            )}

            {/* Add web view proceed button */}
            {!isMobile && (
              <Button
                fullWidth
                className={classes.proceedButton}
                onClick={handleProceed}
                disabled={submitting}
                style={{ marginTop: "24px" }}
              >
                {submitting ? (
                  <CircularProgress size={24} color="inherit" />
                ) : (
                  "Continue to Select Tickets"
                )}
              </Button>
            )}
          </Grid>
        </Grid>

        {isMobile && (
          <Box className={classes.stickyBottomBar}>
            <Box>
              <Typography className={classes.mobileTotalAmount}>
                <AccessTimeIcon
                  fontSize="small"
                  style={{
                    fontSize: 22,
                    verticalAlign: "middle",
                    marginRight: 4,
                    color: "#FF9800",
                    fontWeight: 600,
                  }}
                />
                <span
                  style={{ color: "#FF9800", fontWeight: 600, fontSize: 14 }}
                >
                  Only 13 spots left!
                </span>
              </Typography>
            </Box>
            <Button
              className={classes.mobileProceedButton}
              onClick={handleProceed}
              disabled={submitting}
            >
              {submitting ? (
                <CircularProgress size={20} color="inherit" />
              ) : (
                "Continue"
              )}
            </Button>
          </Box>
        )}
      </Container>
    );
  };

  // Render the passes step (now the second step)
  const renderPassesStep = () => {
    // Only include passes with quantity > 0 for summary
    const selectedPasses = passes.filter((pass) => pass.quantity > 0);

    const getAvailabilityTag = (passTitle) => {
      const spotsLeft = availableSpots[passTitle] || 0;

      if (spotsLeft <= 3) {
        return (
          <Box
            component="span"
            className={`${classes.remainingSpots} ${classes.almostGone}`}
          >
            <WarningIcon /> Only {spotsLeft} left!
          </Box>
        );
      } else if (spotsLeft < 10) {
        return (
          <Box component="span" className={classes.remainingSpots}>
            <WarningIcon /> {spotsLeft} spots left
          </Box>
        );
      }
      return null;
    };

    return (
      <Container className={classes.container}>
        {/* Add floating element for mobile with real countdown */}
        {isMobile && (
          <Box className={classes.floatingBadge}>
            {timeLeft.days > 0 ? (
              <Typography
                variant="body2"
                style={{ fontSize: 12, fontWeight: 600 }}
              >
                Final Countdown: {timeLeft.days}d {timeLeft.hours}h{" "}
                {timeLeft.minutes}m
              </Typography>
            ) : (
              <Typography
                variant="body2"
                style={{ fontSize: 12, fontWeight: 600 }}
              >
                LAST DAY! {timeLeft.hours}h {timeLeft.minutes}m left
              </Typography>
            )}
          </Box>
        )}

        <Grid container spacing={3}>
          <Grid item xs={12} md={7}>
            {renderHeader()}

            <Box mb={2} display="flex" alignItems="center">
              <Button
                startIcon={<ArrowBackIcon />}
                onClick={handleBack}
                style={{ textTransform: "none" }}
              >
                Back to Details
              </Button>
            </Box>

            {passes.map((pass) => (
              <Paper
                key={`${pass.id}-${pass.title}`}
                className={classes.passCard}
              >
                <Box
                  display="flex"
                  justifyContent="space-between"
                  alignItems="flex-start"
                >
                  <Typography variant="h6" className={classes.passTitle}>
                    {pass.title}
                    {getAvailabilityTag(pass.title)}
                  </Typography>

                  {/* {pass.id === "single" && pass.title.includes("Gold") && (
                    <Box
                      bgcolor="#FFF8E1"
                      color="#FF9800"
                      fontWeight={600}
                      fontSize="10px"
                      p={0.5}
                      px={1.5}
                      borderRadius="4px"
                      style={{ alignItems: "center" }}
                    >
                      MOST POPULAR
                    </Box>
                  )} */}
                </Box>

                <Typography variant="body2" className={classes.passDescription}>
                  {pass.description}
                </Typography>
                {pass.title.includes("Single") && (
                  <Typography
                    variant="body2"
                    className={classes.multiMemberNote}
                  >
                    (Please choose Multi-member pass for 2 or more members)
                  </Typography>
                )}

                <List className={classes.featureList}>
                  {pass.features.map((feature, index) => (
                    <ListItem
                      key={index}
                      className={classes.featureItem}
                      disableGutters
                    >
                      <ListItemIcon className={classes.featureIcon}>
                        <FiberManualRecordIcon
                          className={classes.featureBullet}
                        />
                      </ListItemIcon>
                      <ListItemText
                        primary={feature}
                        primaryTypographyProps={{
                          className: classes.featureText,
                        }}
                      />
                    </ListItem>
                  ))}
                </List>

                <Box className={classes.passActions}>
                  <Typography className={classes.passPrice}>
                    {currencySymbol}
                    {pass.price}
                    {pass.originalPrice && pass.originalPrice > pass.price && (
                      <Typography
                        component="span"
                        className={classes.originalPrice}
                        style={{ display: "inline-block", marginLeft: "6px" }}
                      >
                        {currencySymbol}
                        {pass.originalPrice}
                      </Typography>
                    )}
                  </Typography>

                  {/* Show Add to Cart button or quantity control based on whether item is in cart */}
                  {pass.quantity === 0 ? (
                    <Button
                      className={classes.addToCartButton}
                      onClick={() => {
                        // For multi pass, add 2 by default
                        if (pass.title.includes("Multi")) {
                          handleQuantityChange(pass.id, 2, pass.title);
                        } else {
                          handleQuantityChange(pass.id, 1, pass.title);
                        }
                      }}
                    >
                      Add to Cart
                    </Button>
                  ) : (
                    <Box className={classes.quantityControl}>
                      <IconButton
                        className={classes.quantityButton}
                        onClick={() =>
                          handleQuantityChange(pass.id, -1, pass.title)
                        }
                        disabled={pass.quantity === 0}
                        size="small"
                      >
                        <RemoveIcon fontSize="small" />
                      </IconButton>
                      <Typography
                        variant="body1"
                        className={classes.quantityValue}
                      >
                        {pass.quantity}
                      </Typography>
                      <IconButton
                        className={classes.quantityPlusButton}
                        onClick={() =>
                          handleQuantityChange(pass.id, 1, pass.title)
                        }
                        size="small"
                      >
                        <AddIcon fontSize="small" />
                      </IconButton>
                    </Box>
                  )}
                </Box>
              </Paper>
            ))}

            {/* Add testimonials */}
            <Box mt={4} mb={2}>
              <Typography variant="h5" gutterBottom>
                What Previous Attendees Say
              </Typography>

              <Box className={classes.testimonialCard}>
                <Typography className={classes.testimonialQuote}>
                  "The WhatsApp strategies I learned at EVOLVE helped us
                  increase our response rates by 40%. The networking
                  opportunities were invaluable!"
                </Typography>
                <Box className={classes.testimonialAuthor}>
                  <Avatar src="https://randomuser.me/api/portraits/men/34.jpg" />
                  <Box ml={1}>
                    <Typography className={classes.testimonialName}>
                      Mohit Kumar
                    </Typography>
                    <Typography className={classes.testimonialCompany}>
                      Marketing Director, TechSolutions
                    </Typography>
                  </Box>
                </Box>
              </Box>

              <Box className={classes.testimonialCard}>
                <Typography className={classes.testimonialQuote}>
                  "This event was worth every penny! We implemented the AI
                  strategies right away and saw immediate results in our
                  customer engagement."
                </Typography>
                <Box className={classes.testimonialAuthor}>
                  <Avatar src="https://randomuser.me/api/portraits/women/63.jpg" />
                  <Box ml={1}>
                    <Typography className={classes.testimonialName}>
                      Radhika Bisht
                    </Typography>
                    <Typography className={classes.testimonialCompany}>
                      CEO, GrowthFunnel
                    </Typography>
                  </Box>
                </Box>
              </Box>
            </Box>

            {/* Mobile summary now handled directly in sticky bottom bar */}
          </Grid>

          {!isMobile && (
            <Grid item xs={12} md={5}>
              <Card className={classes.summaryCard}>
                <CardContent>
                  <Typography variant="h6" className={classes.summaryTitle}>
                    Order Summary
                  </Typography>

                  {selectedPasses.length === 0 ? (
                    <Box className={classes.emptyCartContainer}>
                      <ShoppingCartIcon className={classes.emptyCartIcon} />
                      <Typography
                        variant="body1"
                        align="center"
                        className={classes.emptyCartText}
                      >
                        Your cart is{" "}
                        <span className={classes.emptyCartHighlight}>
                          empty
                        </span>
                        !
                      </Typography>
                      <Typography
                        variant="body2"
                        align="center"
                        className={classes.emptyCartSubtext}
                      >
                        Secure your spot at this exclusive Dubai event and
                        unlock valuable WhatsApp business resources.
                      </Typography>
                    </Box>
                  ) : (
                    <>
                      {selectedPasses.map((pass) => (
                        <Box
                          key={`summary-${pass.id}-${pass.title}`}
                          className={classes.summaryItem}
                        >
                          <Typography
                            variant="body1"
                            className={classes.summaryItemName}
                          >
                            {pass.title}
                          </Typography>
                          <Typography
                            variant="body2"
                            className={classes.summaryItemQty}
                          >
                            x {pass.quantity}
                          </Typography>
                          <Typography
                            variant="body1"
                            className={classes.summaryItemPrice}
                          >
                            {currencySymbol}
                            {pass.price * pass.quantity}
                          </Typography>
                        </Box>
                      ))}

                      <Divider className={classes.divider} />

                      <Box className={classes.subtotalRow}>
                        <Typography variant="body2">Sub Total</Typography>
                        <Typography variant="body2">
                          {currencySymbol}
                          {getSubtotal().toFixed(2)}
                        </Typography>
                      </Box>

                      {couponApplied && (
                        <Box className={classes.subtotalRow}>
                          <Typography variant="body2" color="primary">
                            Discount
                          </Typography>
                          <Typography variant="body2" color="primary">
                            -{currencySymbol}
                            {discount}
                          </Typography>
                        </Box>
                      )}

                      <Box className={classes.totalRow}>
                        <Typography
                          variant="subtitle1"
                          className={classes.totalLabel}
                        >
                          Total
                        </Typography>
                        <Typography
                          variant="subtitle1"
                          className={classes.totalAmount}
                        >
                          {currencySymbol}
                          {getTotalAmount().toFixed(2)}
                        </Typography>
                      </Box>
                    </>
                  )}

                  <div className={classes.couponSection}>
                    <Typography
                      variant="subtitle2"
                      className={classes.couponLabel}
                    >
                      Apply Coupon Code
                    </Typography>
                    <div className={classes.couponInput}>
                      <TextField
                        className={classes.couponTextField}
                        variant="outlined"
                        placeholder="Enter Code"
                        value={couponCode}
                        onChange={handleCouponChange}
                        fullWidth
                        inputProps={{
                          style: { fontSize: "16px" },
                          autoComplete: "off",
                        }}
                      />
                      <Button
                        className={classes.couponButton}
                        onClick={handleApplyCoupon}
                        disabled={validatingCoupon || !couponCode.trim()}
                      >
                        {validatingCoupon ? (
                          <CircularProgress size={20} color="inherit" />
                        ) : (
                          "Apply"
                        )}
                      </Button>
                    </div>
                    {couponMessage && (
                      <Typography
                        variant="body2"
                        className={
                          couponApplied
                            ? classes.successText
                            : classes.errorText
                        }
                      >
                        {couponApplied && (
                          <CheckCircleIcon className={classes.successIcon} />
                        )}
                        {couponMessage}
                      </Typography>
                    )}
                  </div>

                  <Button
                    fullWidth
                    className={classes.proceedButton}
                    onClick={handleSubmit}
                    disabled={!hasItems() || submitting}
                  >
                    {submitting ? (
                      <CircularProgress size={24} color="inherit" />
                    ) : (
                      `Pay ${currencySymbol}${getTotalAmount().toFixed(2)}`
                    )}
                  </Button>
                </CardContent>
              </Card>
            </Grid>
          )}
        </Grid>

        {isMobile && hasItems() && (
          <Box
            className={classes.stickyBottomBar}
            style={{
              height: summaryExpanded ? "auto" : undefined,
              flexDirection: summaryExpanded ? "column" : "row",
              transition: "all 0.3s ease",
              padding: summaryExpanded
                ? `${theme.spacing(2)}px`
                : `${theme.spacing(1)}px ${theme.spacing(2)}px`,
            }}
          >
            {summaryExpanded ? (
              <>
                <Box
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                  width="100%"
                  mb={1}
                >
                  <Typography variant="subtitle1" style={{ fontWeight: 600 }}>
                    Order Summary
                  </Typography>
                  <IconButton
                    size="small"
                    onClick={() => {
                      // Apply closing animation to summary content
                      const summaryContent =
                        document.querySelector(".summary-content");
                      if (summaryContent) {
                        summaryContent.style.animation =
                          "collapseSummary 0.15s ease";
                        // Wait briefly for animation to play before closing
                        setTimeout(() => setSummaryExpanded(false), 140);
                      } else {
                        setSummaryExpanded(false);
                      }
                    }}
                    style={{ padding: 4 }}
                  >
                    <ExpandMoreIcon />
                  </IconButton>
                </Box>

                <Divider style={{ width: "100%", margin: "0 0 10px 0" }} />

                <Box
                  className="summary-content"
                  style={{
                    maxHeight: "60vh",
                    overflowY: "auto",
                    width: "100%",
                    animation: "$expandSummary 0.1s ease-out", // Ultra-fast animation
                  }}
                >
                  {selectedPasses.map((pass) => (
                    <Box
                      key={`mobile-summary-${pass.id}-${pass.title}`}
                      className={classes.summaryItem}
                      mb={1}
                    >
                      <Typography
                        variant="body1"
                        className={classes.summaryItemName}
                      >
                        {pass.title}
                      </Typography>
                      <Typography
                        variant="body2"
                        className={classes.summaryItemQty}
                      >
                        x {pass.quantity}
                      </Typography>
                      <Typography
                        variant="body1"
                        className={classes.summaryItemPrice}
                      >
                        {currencySymbol}
                        {pass.price * pass.quantity}
                      </Typography>
                    </Box>
                  ))}

                  <Divider style={{ margin: "10px 0" }} />

                  <Box className={classes.subtotalRow}>
                    <Typography variant="body2">Sub Total</Typography>
                    <Typography variant="body2">
                      {currencySymbol}
                      {getSubtotal()}
                    </Typography>
                  </Box>

                  {couponApplied && (
                    <Box className={classes.subtotalRow}>
                      <Typography variant="body2" color="primary">
                        Discount
                      </Typography>
                      <Typography variant="body2" color="primary">
                        -{currencySymbol}
                        {discount}
                      </Typography>
                    </Box>
                  )}

                  <Box
                    className={classes.totalRow}
                    style={{ margin: `${theme.spacing(1)}px 0` }}
                  >
                    <Typography
                      variant="subtitle1"
                      className={classes.totalLabel}
                    >
                      Total
                    </Typography>
                    <Typography
                      variant="subtitle1"
                      className={classes.totalAmount}
                    >
                      {currencySymbol}
                      {getTotalAmount().toFixed(2)}
                    </Typography>
                  </Box>

                  <div className={classes.couponSection}>
                    <Typography
                      variant="subtitle2"
                      className={classes.couponLabel}
                    >
                      Apply Coupon Code
                    </Typography>
                    <div className={classes.couponInput}>
                      <TextField
                        className={classes.couponTextField}
                        variant="outlined"
                        placeholder="Enter Code"
                        value={couponCode}
                        onChange={handleCouponChange}
                        fullWidth
                      />
                      <Button
                        className={classes.couponButton}
                        onClick={handleApplyCoupon}
                        disabled={validatingCoupon || !couponCode.trim()}
                      >
                        {validatingCoupon ? (
                          <CircularProgress size={20} color="inherit" />
                        ) : (
                          "Apply"
                        )}
                      </Button>
                    </div>
                    {couponMessage && (
                      <Typography
                        variant="body2"
                        className={
                          couponApplied
                            ? classes.successText
                            : classes.errorText
                        }
                      >
                        {couponApplied && (
                          <CheckCircleIcon className={classes.successIcon} />
                        )}
                        {couponMessage}
                      </Typography>
                    )}
                  </div>
                </Box>

                <Button
                  fullWidth
                  className={classes.proceedButton}
                  onClick={handleSubmit}
                  disabled={submitting}
                  style={{ marginTop: "16px" }}
                >
                  {submitting ? (
                    <CircularProgress size={24} color="inherit" />
                  ) : (
                    `Pay ${currencySymbol}${getTotalAmount().toFixed(2)}`
                  )}
                </Button>
              </>
            ) : (
              // Collapsed view - basic info
              <>
                <Box>
                  <Typography className={classes.mobileTotal}>
                    Total: {currencySymbol} {getTotalAmount().toFixed(2)}
                  </Typography>
                  <Typography
                    className={classes.mobileTotalAmount}
                    onClick={() => setSummaryExpanded(true)}
                    style={{
                      cursor: "pointer",
                      display: "flex",
                      alignItems: "center",
                      color: "#04cf66",
                      fontWeight: 500,
                    }}
                  >
                    View Ticket Summary
                    <ExpandLessIcon
                      style={{
                        fontSize: 16,
                        marginLeft: 4,
                        transition: "transform 0.3s ease",
                      }}
                    />
                  </Typography>
                </Box>
                <Button
                  className={classes.mobileProceedButton}
                  onClick={handleSubmit}
                  disabled={submitting}
                >
                  {submitting ? (
                    <CircularProgress size={20} color="inherit" />
                  ) : (
                    `Pay Now`
                  )}
                </Button>
              </>
            )}
          </Box>
        )}
      </Container>
    );
  };

  // Handle summary accordion expansion
  const handleSummaryToggle = () => {
    setSummaryExpanded(!summaryExpanded);
  };

  // Render the summary (right column)
  const renderSummary = () => {
    // Only include passes with quantity > 0
    const selectedPasses = passes.filter((pass) => pass.quantity > 0);
    const isEmpty = selectedPasses.length === 0;

    return (
      <Card className={classes.summaryCard}>
        <CardContent style={{ padding: "16px" }}>
          <Typography variant="h6" className={classes.summaryTitle}>
            Ticket Summary
          </Typography>

          {isEmpty ? (
            <Box className={classes.emptyCartContainer}>
              <ShoppingCartIcon className={classes.emptyCartIcon} />
              <Typography
                variant="body1"
                align="center"
                className={classes.emptyCartText}
              >
                Your cart is{" "}
                <span className={classes.emptyCartHighlight}>empty</span>!
              </Typography>
              <Typography
                variant="body2"
                align="center"
                className={classes.emptyCartSubtext}
              >
                Secure your spot at this exclusive Dubai event and unlock
                valuable WhatsApp business resources. .
              </Typography>
            </Box>
          ) : (
            <>
              {selectedPasses.map((pass) => (
                <Box
                  key={`summary-${pass.id}-${pass.title}`}
                  className={classes.summaryItem}
                >
                  <Typography
                    variant="body1"
                    className={classes.summaryItemName}
                  >
                    {pass.title}
                  </Typography>
                  <Typography
                    variant="body2"
                    className={classes.summaryItemQty}
                  >
                    x {pass.quantity}
                  </Typography>
                  <Typography
                    variant="body1"
                    className={classes.summaryItemPrice}
                  >
                    {currencySymbol}
                    {pass.price * pass.quantity}
                  </Typography>
                </Box>
              ))}

              <Divider className={classes.divider} />

              <Box className={classes.subtotalRow}>
                <Typography variant="body2">Sub Total</Typography>
                <Typography variant="body2">
                  {currencySymbol}
                  {getSubtotal()}
                </Typography>
              </Box>

              {couponApplied && (
                <Box className={classes.subtotalRow}>
                  <Typography variant="body2" color="primary">
                    Discount
                  </Typography>
                  <Typography variant="body2" color="primary">
                    -{currencySymbol}
                    {discount}
                  </Typography>
                </Box>
              )}

              <Box className={classes.totalRow}>
                <Typography variant="subtitle1" className={classes.totalLabel}>
                  Total
                </Typography>
                <Typography variant="subtitle1" className={classes.totalAmount}>
                  {currencySymbol}
                  {getTotalAmount().toFixed(2)}
                </Typography>
              </Box>
            </>
          )}

          <div className={classes.couponSection}>
            <Typography variant="subtitle2" className={classes.couponLabel}>
              Apply Coupon Code
            </Typography>
            <div className={classes.couponInput}>
              <TextField
                className={classes.couponTextField}
                variant="outlined"
                placeholder="Enter Code"
                value={couponCode}
                onChange={handleCouponChange}
                fullWidth
              />
              <Button
                className={classes.couponButton}
                onClick={handleApplyCoupon}
                disabled={validatingCoupon || !couponCode.trim()}
              >
                {validatingCoupon ? (
                  <CircularProgress size={20} color="inherit" />
                ) : (
                  "Apply"
                )}
              </Button>
            </div>
            {couponMessage && (
              <Typography
                variant="body2"
                className={
                  couponApplied ? classes.successText : classes.errorText
                }
              >
                {couponApplied && (
                  <CheckCircleIcon className={classes.successIcon} />
                )}
                {couponMessage}
              </Typography>
            )}
          </div>

          <Button
            fullWidth
            className={classes.proceedButton}
            onClick={handleProceed}
            disabled={!hasItems()}
          >
            Proceed
          </Button>
        </CardContent>
      </Card>
    );
  };

  // Render bottom sticky bar for mobile view
  const renderMobileFooter = () => {
    const hasSelectedItems = hasItems();

    if (!hasSelectedItems) {
      return null; // Don't show footer if no items selected
    }

    return (
      <Box className={classes.stickyBottomBar}>
        <Box>
          <Typography className={classes.mobileTotal}>
            Total: {currencySymbol} {getTotalAmount().toFixed(2)}
          </Typography>
        </Box>
        <Button
          className={classes.mobileProceedButton}
          onClick={handleProceed}
          disabled={!hasSelectedItems}
        >
          Proceed
        </Button>
      </Box>
    );
  };

  // Original countdown timer replaced with real-time countdown below

  // Add countdown timer component
  const CountdownTimer = () => {
    return (
      <Box className={classes.countdownTimer}>
        <Box className={classes.countdownUnit}>
          <Typography className={classes.countdownNumber}>
            {timeLeft.days}
          </Typography>
          <Typography className={classes.countdownLabel}>days</Typography>
        </Box>
        <Typography>:</Typography>
        <Box className={classes.countdownUnit}>
          <Typography className={classes.countdownNumber}>
            {timeLeft.hours}
          </Typography>
          <Typography className={classes.countdownLabel}>hrs</Typography>
        </Box>
        <Typography>:</Typography>
        <Box className={classes.countdownUnit}>
          <Typography className={classes.countdownNumber}>
            {timeLeft.minutes}
          </Typography>
          <Typography className={classes.countdownLabel}>mins</Typography>
        </Box>
      </Box>
    );
  };

  // Add useEffect for countdown timer that uses the actual end date
  useEffect(() => {
    // Set the date we're counting down to
    const countDownDate = new Date("April 25, 2025 10:59:59").getTime();

    // Update the countdown every minute
    const updateCountdown = () => {
      // Get current date and time
      const now = new Date().getTime();

      // Find the distance between now and the countdown date
      const distance = countDownDate - now;

      // Calculate days, hours, minutes
      const days = Math.floor(distance / (1000 * 60 * 60 * 24));
      const hours = Math.floor(
        (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
      );
      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));

      // If the countdown is over, stop the interval
      if (distance < 0) {
        clearInterval(interval);
        setTimeLeft({ days: 0, hours: 0, minutes: 0 });
      } else {
        setTimeLeft({ days, hours, minutes });
      }
    };

    // Run immediately once
    updateCountdown();

    // Then update every minute
    const interval = setInterval(updateCountdown, 60000);

    // Clear interval on component unmount
    return () => clearInterval(interval);
  }, []);

  // Add a useEffect to inject meta tag to prevent auto-zoom on iOS
  useEffect(() => {
    // Add meta tag to prevent zooming when input is focused on mobile devices
    const metaTag = document.createElement("meta");
    metaTag.name = "viewport";
    metaTag.content =
      "width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no";
    document.getElementsByTagName("head")[0].appendChild(metaTag);

    // Add Plausible analytics script
    const plausibleScript = document.createElement("script");
    plausibleScript.defer = true;
    plausibleScript.setAttribute("data-domain", "checkout.aisensy.com");
    plausibleScript.src = "https://plausible.io/js/script.js";
    document.getElementsByTagName("head")[0].appendChild(plausibleScript);

    // Add Pagesense tracking script
    const pagesenseScript = document.createElement("script");
    pagesenseScript.type = "text/javascript";
    pagesenseScript.async = true;
    pagesenseScript.src =
      "https://cdn-in.pagesense.io/js/aisensy/23640c72623a4639b23b58efd93a4209.js";

    // Insert Pagesense script before the first script in the document
    const firstScript = document.getElementsByTagName("script")[0];
    firstScript.parentNode.insertBefore(pagesenseScript, firstScript);

    // Add additional Meta Pixel code with ID 890505489280353
    const additionalPixelScript = document.createElement("script");
    additionalPixelScript.id = "fb-pixel-additional";
    additionalPixelScript.innerHTML = `
      !function(f,b,e,v,n,t,s)
      {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
      n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t,s)}(window, document,'script',
      'https://connect.facebook.net/en_US/fbevents.js');
      fbq('init', '890505489280353');
      fbq('track', 'PageView');
    `;
    document.head.appendChild(additionalPixelScript);

    // Add noscript pixel for browsers with JavaScript disabled
    const additionalNoscript = document.createElement("noscript");
    const additionalImg = document.createElement("img");
    additionalImg.height = "1";
    additionalImg.width = "1";
    additionalImg.style.display = "none";
    additionalImg.src =
      "https://www.facebook.com/tr?id=890505489280353&ev=PageView&noscript=1";
    additionalNoscript.appendChild(additionalImg);
    document.head.appendChild(additionalNoscript);

    return () => {
      document.getElementsByTagName("head")[0].removeChild(metaTag);
      if (document.head.contains(plausibleScript)) {
        document.getElementsByTagName("head")[0].removeChild(plausibleScript);
      }
      if (document.contains(pagesenseScript)) {
        pagesenseScript.parentNode.removeChild(pagesenseScript);
      }
      // Clean up additional Meta Pixel
      if (document.head.contains(additionalPixelScript)) {
        document.head.removeChild(additionalPixelScript);
      }
      if (document.head.contains(additionalNoscript)) {
        document.head.removeChild(additionalNoscript);
      }
    };
  }, []);

  useEffect(() => {
    // Inject Google Tag Manager
    const gtmScript = document.createElement('script');
    gtmScript.innerHTML = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
    new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
    j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
    'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
    })(window,document,'script','dataLayer','GTM-NRR25F8');`;
    document.head.appendChild(gtmScript);

    // Inject Google Analytics
    const gtagScript = document.createElement('script');
    gtagScript.async = true;
    gtagScript.src = 'https://www.googletagmanager.com/gtag/js?id=G-B7BMELF36T';
    document.head.appendChild(gtagScript);

    const gtagConfigScript = document.createElement('script');
    gtagConfigScript.innerHTML = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', 'G-B7BMELF36T');
    `;
    document.head.appendChild(gtagConfigScript);

    return () => {
      // Clean up scripts when component unmounts
      document.head.removeChild(gtmScript);
      document.head.removeChild(gtagScript);
      document.head.removeChild(gtagConfigScript);
    };
  }, []);

  if (loading) {
    return (
      <div className={classes.loadingContainer}>
        <CircularProgress />
      </div>
    );
  }

  return (
    <div className={classes.root}>
      <div className={classes.dubaiFlair}></div>

      {/* Render appropriate step based on activeStep */}
      {activeStep === 0 ? renderUserDetailsStep() : renderPassesStep()}

      <Snackbar
        open={showError}
        autoHideDuration={4000}
        onClose={handleCloseError}
        message={error}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        ContentProps={{
          className: classes.errorSnackbar,
        }}
      />

      <Snackbar
        open={showQuantityMsg}
        autoHideDuration={4000}
        onClose={handleCloseQuantityMsg}
        message={quantityMsg}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        ContentProps={{
          style: {
            backgroundColor: "#424242",
            fontWeight: 500,
          },
        }}
      />
    </div>
  );
}

export default AiSensyPaymentPage;
